// extracted by mini-css-extract-plugin
export default {"nav-bar":"Gy5bC9atScCYfZ9LndPA","nav-links":"vCHCd_K8muBkVz4J27DE","right-display":"jVqUWTJbBy58grnU92WJ","user-icon-menu":"P6SaEIJY_lhMkKQ0R_4X"};